import LoadingButton from '@mui/lab/LoadingButton';
import { $black } from 'constants/styles';
import PropTypes from 'prop-types';
import ErrorTooltip from 'components/navigation/ErrorTooltip';
import { Link } from '@mui/material';
import { linkBaseUrl } from 'constants/generalConstants';
import { useTranslation } from 'react-i18next';

function ButtonOutline(properties) {
	const { t } = useTranslation();
	const {
		content,
		textColor,
		handleAction,
		styles,
		size,
		loading = false,
		icon = <div />,
		disabled,
		disabledTooltip
	} = properties;

	const buttonStyles = {
		button: {
			fontSize: '14px',
			textTransform: 'none',
			fontWeight: 700,
			color: $black,
			border: `solid 1px ${$black}`,
			borderRadius: 0,
			height: '40px',
			width: 'auto'
		},
		toolTipLink: {
			color: '#fff',
			textDecoration: 'none !important'
		}
	};

	return disabledTooltip ? (
		<ErrorTooltip
			title={
				<Link href={`${linkBaseUrl}/contact/`} target={'_blank'} sx={buttonStyles.toolTipLink}>
					{t('This feature is for enterprise users only')}.
					<br />
					{t('Contact us to sign up')}.
				</Link>
			}
			placement='bottom'
		>
			<span>
				<LoadingButton
					color={textColor}
					onClick={handleAction}
					sx={buttonStyles.button}
					style={styles}
					variant='outlined'
					size={size}
					loading={loading}
					loadingPosition='start'
					startIcon={icon}
					disabled={disabled}
				>
					{content}
				</LoadingButton>
			</span>
		</ErrorTooltip>
	) : (
		<LoadingButton
			color={textColor}
			onClick={handleAction}
			sx={buttonStyles.button}
			style={styles}
			variant='outlined'
			size={size}
			loading={loading}
			loadingPosition='start'
			startIcon={icon}
			disabled={disabled}
		>
			{content}
		</LoadingButton>
	);
}

ButtonOutline.propTypes = {
	content: PropTypes.any,
	textColor: PropTypes.string,
	handleAction: PropTypes.func,
	styles: PropTypes.object,
	size: PropTypes.string,
	loading: PropTypes.bool,
	icon: PropTypes.element,
	disabled: PropTypes.bool,
	disabledTooltip: PropTypes.bool
};

export default ButtonOutline;
